import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=988e5c4a&scoped=true&"
import script from "./Master.vue?vue&type=script&lang=ts&"
export * from "./Master.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988e5c4a",
  null
  
)

export default component.exports